import { render } from "./AboutMap.vue?vue&type=template&id=49d06bcc"
import script from "./AboutMap.vue?vue&type=script&lang=js"
export * from "./AboutMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__